import React from "react";
import dynamic from "next/dynamic";
import type { IPlayerProps } from "@lottiefiles/react-lottie-player";

const ClientPlayer = dynamic<IPlayerProps>(
  () =>
    import("@lottiefiles/react-lottie-player").then((mod) => mod.Player),
  {
    ssr: false,
  }
);

export default function LottiePlayer(props: IPlayerProps) {
  return <ClientPlayer {...props} />;
}
